import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';
import { gutters } from 'app/spacing';

export const StyledKizenTypography = styled(KizenTypography)`
  padding-bottom: ${gutters.spacing(3, 3)}px;
`;
